module.exports = {
  app: {
    aside: {
      nav: {
        start: '开发指南',
        install: '安装',
        use: '快速上手',
        global: '全局参数',
        icons: '全局图标',
        theme: '全局主题',
        i18n: '国际化',

        icon: '图标',
        basics: '基础表格',
        base: '基础',
        size: '尺寸',
        width: '列宽',
        ellipsis: '单元格溢出省略号',
        tooltips: '单元格工具提示',
        stripe: '斑马线条纹',
        border: '边框',
        round: '圆角边框',
        style: '单元格样式',
        dynamicStyle: '单元格动态样式',
        scrollStyle: '滚动条样式',
        hideHead: '隐藏头部',
        resizable: '列宽拖动',
        fluidHeight: '最大高度',
        resize: '响应式宽高',
        height: '固定表头',
        fixed: '固定列',
        fullFixed: '固定表头和列',
        group: '表头分组',
        seq: '序号',
        headerHighlight: '高亮列',
        current: '高亮行',
        radio: '单选框',
        checkbox: '复选框',
        sort: '排序',
        filter: '筛选',
        empty: '空数据',
        loading: '加载中',
        format: '格式化内容',
        html: 'HTML 标签',
        data: '数据格式与字段',

        more: '复杂表格',
        events: '事件绑定',
        template: '自定义模板',
        dynamic: '使用 v-for 动态实现',
        sortIcon: '自定义排序图标',
        customSort: '实现列头排序',
        manualFilter: '筛选高级用法',
        filterIcon: '自定义筛选图标',
        span: '合并行或列',
        spanRow: '合并横向树列表',
        mergeCell: '合并复杂的报表',
        footer: '表尾',
        footerSpan: '表尾合并行或列',
        import: '导入数据',
        export: '导出数据',
        print: '打印',
        fixedType: '固定类型 + 导入/导出',
        contextMenu: '快捷菜单',
        menuPrivilege: '快捷菜单 + 权限控制',
        footerImmediately: '表尾 + 实时更新合计',
        expandRow: '展开行',
        expandRowIcon: '展开行 + 更多自定义',
        expandRowLazy: '展开行 + 懒加载',
        accordion: '手风琴展开效果',
        toolbar: '工具栏',
        customs: '显示/隐藏列',
        customStorage: '显示/隐藏列 + localStorage',
        customlWidthStorage: '显示/隐藏/列宽 + localStorage',
        search: '全表搜索',
        groupBy: '行分组',
        details: '弹框显示详情',
        popupEdit: '弹框表单编辑',
        pager: '分页',
        pageIcon: '分页 + 自定义图标',
        rangeSelect: '复选框的范围选中',
        tabs: '多页签切换',
        keepAlives: 'keep-alive 切换',

        grid: '高级表格',
        reverse: '反转表格',
        proxy: '数据代理',
        proxyPage: '数据代理 + 分页',
        formProxy: '数据代理 + 表单',
        configProxy: '进阶封装',
        fullQuery: '完整查询',
        customToolbar: '自定义工具栏',
        toolbarIcon: '自定义工具栏按钮图标',
        fullscreen: '全屏缩放',
        dynamicColumn: '实现可配置动态列',
        baseTree: '基础树',
        lazyTree: '懒加载树',
        treeLazyEdit: '懒加载树 + 可编辑',
        crudTreeToolbar: '树表格 + 工具栏',

        tree: '树形表格',
        treeNormal: '普通树',
        customIcon: '更多自定义',
        expandTreeLazy: '树形展开行懒加载',
        treeSearch: '深层查找',
        treeSort: '深层排序',
        groupSummary: '分组汇总',
        groupSummaryCount: '分组汇总合计',
        edit: '可编辑',
        crudToolbar: '增删改查 + 工具栏',
        lazy: '懒加载',
        lazyMenu: '懒加载 + 快捷菜单',
        lazyEdit: '懒加载 + 可编辑',
        treeLine: '连接线',
        full: '完整功能',

        virtualTree: '虚拟树表格',
        big: '虚拟滚动',

        scroll: '大数据表格',
        bigData: '虚拟滚动',
        scrollRows: '纵向',
        scrollFullRows: '纵向 + 复杂渲染',
        scrollCols: '横向&纵向',
        scrollFullCols: '横向&纵向 + 复杂渲染',
        moveHighlight: '键盘移动高亮行',
        scrollTree: '虚拟树',
        bigTree: '树形纵向',
        treeRows: '树形纵向',
        treeCols: '树形横向&纵向',
        pageScroll: '滚动分页',
        infiniteScroll: '无限滚动',
        partialLoad: '局部加载',
        fullPartialLoad: '完整的局部加载',

        editable: '编辑表格',
        popupForm: '弹框编辑',
        manual: '手动触发',
        click: '点击触发',
        dblclick: '双击触发',
        selectContent: '选中内容',
        autoClear: '关闭自动清除',
        insert: '插入数据',
        delete: '删除数据',
        revert: '还原数据',
        status: '数据更新',
        cellDisable: '禁用编辑 cell',
        rowDisable: '禁用编辑 row',
        cellValid: '数据校验 call',
        rowValid: '数据校验 row',
        forceCellValid: '数据校验 cell + 强制锁定',
        forceRowValid: '数据校验 row + 强制锁定',
        highlightCell: '高亮编辑',
        keyboard: '键盘导航',
        keyboardEdit: '键盘导航 + 重写默认编辑行为',
        dataCount: '数据联动计算',
        uniqueSelect: '唯一下拉选项',
        cascadingSelect: '联动下拉选项',
        realtimeSave: '实时保存',
        upload: '文件上传',

        excel: '更多实现',
        cell: '单元格',

        bad: '糟糕的用法',
        badEdit: '全表渲染为编辑状态',
        badLineHeight: '动态行高与虚拟滚动的取舍',
        badNonsupport: '不被支持的用法',

        module: '功能模块',
        button: '按钮',
        input: '输入框',
        textarea: '文本域',
        select: '下拉框',
        modal: '模态窗口',
        tooltip: '文字提示',
        form: '表单',
        switch: '开关',
        list: '列表',
        pulldown: '下拉容器',

        other: '集成第三方库',
        elementRender: 'element-ui -> 自定义渲染',
        iviewRender: 'iview -> 自定义渲染',
        antd: 'ant-design-vue -> 自定义渲染',
        elementUpload: 'element-ui -> 附件上传',
        sortablejsRow: 'sortablejs -> 行拖拽',
        sortablejsColumn: 'sortablejs -> 列拖拽',
        xlsxRender: 'xlsx -> 导入与导出',

        plugin: '扩展插件库',
        elementPlugin: 'plugin-element 基本配置',
        elementFilterPlugin: 'plugin-element 筛选配置',
        elementPluginMore: 'plugin-element 更多配置',
        iviewPlugin: 'plugin-iview 基本配置',
        iviewFilter: 'plugin-iview 筛选配置',
        iviewPluginMore: 'plugin-iview 更多配置',
        antdPlugin: 'plugin-antd 基本配置',
        antdFilter: 'plugin-antd 筛选配置',
        antdPluginMore: 'plugin-antd 更多配置',
        spanPlugin: '单元格选中合并',
        shortcutKeyPlugin: 'plugin-shortcut-key 快捷键设置',
        chartsPlugin: 'plugin-charts 图表工具',
        exportXLSXPlugin: 'plugin-export 导出 xlsx',
        exportPDFPlugin: 'plugin-export 导出 pdf',
        rendererPlugin: 'plugin-renderer 更多渲染器',
        menusPlugin: 'plugin-menus 快捷菜单集',
        excelPlugin: 'plugin-excel 简单的 Excel',
        treeRowPlugin: 'plugin-virtual-tree 虚拟树',
        treeColPlugin: 'plugin-virtual-tree 横向与纵向',

        formats: '(全局) 格式化',
        commands: '(全局) 指令注册',
        menus: '(全局) 快捷菜单',

        renderer: '(复用) 渲染器',
        rendererFilter: '筛选渲染',
        rendererDefault: '单元格渲染',
        rendererEdit: '可编辑渲染',
        rendererExpand: '内容渲染',
        rendererToolbar: '工具栏渲染',
        rendererForm: '表单渲染',
        rendererEmpty: '空数据渲染',

        interceptor: '(兼容) 事件拦截',

        optimize: '优化建议',
        optimizeScroller: '虚拟滚动优化',
        optimizeEdit: '可编辑优化',

        api: 'API',
        vxeTable: 'vxe-table',
        vxeTableColumn: 'vxe-table-column',
        vxeGrid: 'vxe-grid',
        vxeVirtualTree: 'vxe-virtual-tree',
        vxeExcel: 'vxe-excel',
        vxeToolbar: 'vxe-toolbar',
        vxePager: 'vxe-pager',
        vxeRadio: 'vxe-radio',
        vxeCheckbox: 'vxe-checkbox',
        vxeInput: 'vxe-input',
        vxeTextarea: 'vxe-textarea',
        vxeSelect: 'vxe-select',
        vxeOptgroup: 'vxe-optgroup',
        vxeOption: 'vxe-option',
        vxeButton: 'vxe-button',
        vxeTooltip: 'vxe-tooltip',
        vxeModal: 'vxe-modal',
        vxeForm: 'vxe-form',
        vxeFormItem: 'vxe-form-item',
        vxeSwitch: 'vxe-switch',
        vxeList: 'vxe-list',
        vxePulldown: 'vxe-pulldown'
      }
    },
    body: {
      button: {
        viewCode: '查看代码',
        runDemo: '在线运行',
        showCode: '显示代码',
        refresh: '刷新',
        insert: '新增',
        save: '保存',
        markCancel: '标记/取消',
        deleteSelectedRecords: '删除选中'
      },
      label: {
        on: '开',
        off: '关',
        plan: '计划',
        through: '通过',
        copy: '复制',
        cut: '剪贴',
        paste: '粘贴',
        delete: '删除',
        sort: '排序',
        filter: '筛选',
        translations: '语言',
        version: '版本',
        name: '名字',
        age: '年龄',
        sex: '性别',
        search: '查询',
        reset: '重置',
        createTime: '创建时间',
        updateTime: '更新时间',
        stableVersion: '稳定版',
        latestVersion: '最新版'
      },
      valid: {
        rName: '名称必须填写'
      },
      msg: {
        error: '错误提示',
        copyToClipboard: '已复制到剪贴板！'
      },
      other: {
        plan: {
          v1: 'v1 基于 vue2.6+，支持所有主流的浏览器，实现表格的一切实用的功能',
          v2: 'v2 基于 vue2.6+，支持所有主的流浏览，同时兼具功能与性能',
          v3: 'v3 基于 vue2.6+，只支持 H5 浏览器，不支持 IE，渲染性能大幅提升',
          v4: 'v4 基于 vue3+，只支持 H5 浏览器，不支持 IE，渲染性能大幅提升'
        },
        ways: {
          wechat: '通过以下 微信扫码 捐赠',
          alipay: '通过以下 支付宝扫码 捐赠',
          gitee: '通过 <a class="link" href="https://gitee.com/xuliangzhan_admin/vxe-table#donation" target="_blank">Gitee 捐赠</a> （该方式可以在项目中查看 <a class="link" href="https://gitee.com/xuliangzhan_admin/vxe-table#donation" target="_blank">捐赠记录</a>）'
        },
        compatibility: '兼容性变动',
        releases: '更新日志',
        donation: '捐赠',
        donationTitle: '捐赠方式<span class="red">（如果有无法解决的问题可以留言或者提 <a class="link" href="https://github.com/x-extends/vxe-table/issues/390" target="_blank">Issues</a>）</span>：',
        issuesTitle: '如何反馈问题？  ',
        newFunc: '由于作者比较忙，后续有时间可能会支持该功能！',
        newDevelopment: '由于作者比较忙，该版本正在重构中，敬请期待！'
      },
      search: {
        searchPlaceholder: '文档搜索',
        noDataPrefix: '找不到与 “',
        noDataSuffix: '” 相关的结果！'
      }
    },
    footer: {
      donation: '捐赠',
      donationDesc: 'vxe-table 采用 MIT 许可的开源项目，使用完全免费。为了使项目能够健康持续的发展下去，您可以通过捐赠来支持作者 😊'
    },
    api: {
      apiSearch: 'API 搜索',
      title: {
        prop: '属性',
        desc: '说明',
        type: '类型 / 返回类型',
        enum: '可选值',
        defVal: '默认值 / 参数',
        version: '兼容性',
        props: '参数',
        events: '事件',
        slots: '插槽',
        methods: '方法'
      },
      table: {
        desc: {
          id: '唯一标识（被某些特定的功能所依赖）',
          data: '表格数据（与 loadData 行为一致，更新数据是不会重置状态）',
          columns: '列配置',
          customs: '即将废弃',
          height: '表格的高度；支持铺满父容器或者固定高度，如果设置 auto 为铺满父容器（如果设置自适应时，必须确保存在父节点且不允许存在相邻元素）',
          maxHeight: '表格的最大高度',
          syncResize: '自动跟随某个属性的变化去重新计算表格，和手动调用 recalculate 方法是一样的效果（对于通过某个属性来控制显示/隐藏切换时可能会用到）',
          autoResize: '自动监听父元素的变化去重新计算表格（对于父元素可能存在动态变化、显示隐藏的容器中、列宽异常等场景中的可能会用到）',
          resizable: '所有的列是否允许拖动列宽调整大小',
          stripe: '是否带有斑马纹（需要注意的是，在可编辑表格场景下，临时插入的数据不会有斑马纹样式）',
          border: '是否带有边框',
          round: '是否为圆角边框',
          size: '表格的尺寸',
          fit: '所有列的宽度是否自撑开（可能会被废弃的参数，不要使用）',
          loading: '表格是否显示加载中',
          align: '所有的列对齐方式',
          headerAlign: '所有的表头列的对齐方式',
          footerAlign: '所有的表尾列的对齐方式',
          showHeader: '是否显示表头',
          startIndex: '即将废弃，请使用 seq-config.startIndex',
          highlightCurrentRow: '是否要高亮当前行',
          highlightHoverRow: '鼠标移到行是否要高亮显示',
          highlightCurrentColumn: '是否要高亮当前列',
          highlightHoverColumn: '鼠标移到列是否要高亮显示',
          highlightCell: '只对 edit-config 配置时有效，是否在编辑时高亮单元格边框（只支持部分）',
          rowClassName: '给行附加 className，也可以是函数 Function({row, rowIndex, $rowIndex})',
          cellClassName: '给单元格附加 className，也可以是函数 Function({row, rowIndex, $rowIndex, column, columnIndex, $columnIndex})',
          headerRowClassName: '给表头的行附加 className，也可以是函数 Function({$rowIndex})',
          headerCellClassName: '给表头的单元格附加 className，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          footerRowClassName: '给表尾的行附加 className，也可以是函数 Function({$rowIndex})',
          footerCellClassName: '给表尾的单元格附加 className，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          cellStyle: '给单元格附加样式，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          headerCellStyle: '给表头单元格附加样式，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          footerCellStyle: '给表尾单元格附加样式，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          rowStyle: '给行附加样式，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          headerRowStyle: '给表头行附加样式，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          footerRowStyle: '给表尾行附加样式，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          showFooter: '是否显示表尾',
          footerMethod: '表尾的数据获取方法 Function({columns, data}) 返回一个二维数组',
          spanMethod: '合并行或列，该函数 Function({row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, data}) 返回计算后的值',
          footerSpanMethod: '表尾合并行或列，该函数 Function({$rowIndex, column, columnIndex, $columnIndex, data}) 返回计算后的值',
          showOverflow: '设置所有内容过长时显示为省略号（如果是固定列建议设置该值，提升渲染速度）',
          showHeaderOverflow: '设置表头所有内容过长时显示为省略号',
          showAllOverflow: '即将废弃，请使用 show-overflow',
          showHeaderAllOverflow: '即将废弃，请使用 show-header-overflow',
          showFooterOverflow: '设置表尾所有内容过长时显示为省略号',
          sortMethod: '即将废弃，请使用 sort-config.sortMethod',
          remoteSort: '即将废弃，请使用 sort-config.remote',
          remoteFilter: '即将废弃，请使用 filter-config.remote',
          columnWidth: '所有列宽度',
          columnMinWidth: '所有最小列宽度；会自动将剩余空间按比例分配',
          columnKey: '是否需要为每一列的 VNode 设置 key 属性（非特殊情况下不需要使用）',
          rowKey: '是否需要为每一行的 VNode 设置 key 属性（非特殊情况下没必要设置）',
          rowId: '自定义行数据唯一主键的字段名（行数据必须要有唯一主键，默认自动生成）',
          keepSource: '保持原始值的状态，被某些功能所依赖，比如编辑状态、还原数据等（开启后性能直线下降，具体取决于数据量）',
          zIndex: '自定义堆叠顺序（对于某些特殊场景，比如被遮挡时可能会用到）',
          seqConfig: '序号配置项',
          sortConfig: '排序配置项',
          filterConfig: '筛选配置项',
          radioConfig: '单选框配置项',
          exportConfig: '导出配置项',
          importConfig: '导入配置项',
          printConfig: '打印配置项',
          selectConfig: '即将废弃，请使用 checkbox-config',
          checkboxConfig: '复选框配置项',
          tooltipConfig: 'tooltip 配置项',
          expandConfig: '展开行配置项',
          treeConfig: '树形结构配置项',
          contextMenu: '快捷菜单配置项',
          mouseConfig: '鼠标配置项（只对 edit-config.mode=cell 有效）',
          keyboardConfig: '按键配置项',
          editConfig: '可编辑配置项',
          validConfig: '校验配置项',
          editRules: '校验规则配置项',
          emptyRender: '空内容渲染配置项',
          customConfig: '自定义列配置项',
          optimization: '即将废弃',

          params: '额外的参数（可以用来存放一些私有参数）',

          empty: '空数据时显示的文本内容',

          currentChange: '只对 highlightCurrentRow 有效，当手动选中行并且值发生改变时触发的事件',
          radioChange: '只对 type=radio 有效，当手动勾选并且值发生改变时触发的事件',
          selectChange: '即将废弃，请使用 checkbox-change',
          checkboxChange: '只对 type=checkbox 有效，当手动勾选并且值发生改变时触发的事件',
          selectAll: '即将废弃，请使用 checkbox-all',
          checkboxAll: '只对 type=checkbox 有效，当手动勾选全选时触发的事件',
          cellClick: '单元格被点击时会触发该事件',
          cellDblclick: '单元格被双击时会触发该事件',
          cellContextmenu: '只对 context-menu 配置时有效，单元格被鼠标右键时触发该事件',
          headerCellClick: '表头单元格被点击时会触发该事件',
          headerCellDblclick: '表头单元格被双击时会触发该事件',
          headerCellContextmenu: '只对 context-menu 配置时有效，表头单元格被鼠标右键时触发该事件',
          footerCellClick: '表尾单元格被点击时会触发该事件',
          footerCellDblclick: '表尾单元格被双击时会触发该事件',
          footerCellContextmenu: '只对 context-menu 配置时有效，表尾单元格被鼠标右键时触发该事件',
          cellMouseenter: '当单元格 hover 进入时会触发该事件',
          cellMouseleave: '当单元格 hover 退出时会触发该事件',
          sortChange: '当排序条件发生变化时会触发该事件',
          filterChange: '当筛选条件发生变化时会触发该事件',
          resizableChange: '当列宽拖动发生变化时会触发该事件',
          toggleExpandChange: '当行展开或收起时会触发该事件',
          toggleTreeChange: '当树节点展开或收起时会触发该事件',
          contextMenuClick: '只对 context-menu 配置时有效，当点击快捷菜单时会触发该事件',
          editClosed: '只对 edit-config 配置时有效，单元格编辑状态下被关闭时会触发该事件',
          editActived: '只对 edit-config 配置时有效，单元格被激活编辑时会触发该事件',
          editDisabled: '只对 edit-config 配置时有效，当单元格激活时如果是禁用状态时会触发该事件',
          validError: '只对 edit-rules 配置时有效，当数据校验不通过时会触发该事件',
          scroll: '表格滚动时会触发该事件'
        }
      },
      tableColumn: {
        desc: {
          type: '列的类型',
          index: '即将废弃，请使用 seq',
          seq: '序号',
          selection: '即将废弃，请使用 checkbox',
          checkbox: '复选框',
          radio: '单选框',
          expand: '展开行',
          html: 'HTML 标签（动态渲染任意 HTML 是非常危险的，很容易导致 XSS 攻击，请确保内容是可信的）',
          prop: '即将废弃，请使用 field',
          visible: '列是否显示',
          field: '列字段名（注：属性层级越深，渲染性能将直线下降，例如：aa.bb.cc）',
          label: '即将废弃，请使用 title',
          title: '列标题（支持开启国际化）',
          width: '列宽度（如果为空则均匀分配剩余宽度，如果全部列固定了，可能会存在宽屏下不会铺满，可以配合 "%" 或者 "min-width" 布局）',
          minWidth: '最小列宽度；会自动将剩余空间按比例分配',
          resizable: '列是否允许拖动列宽调整大小',
          fixed: '将列固定在左侧或者右侧（注意：固定列应该放在左右两侧的位置）',
          align: '列对齐方式',
          headerAlign: '表头列的对齐方式',
          footerAlign: '表尾列的对齐方式',
          showOverflow: '当内容过长时显示为省略号',
          showHeaderOverflow: '当表头内容过长时显示为省略号',
          showFooterOverflow: '当表尾内容过长时显示为省略号',
          className: '给单元格附加 className，也可以是函数 Function({row, rowIndex, $rowIndex, column, columnIndex, $columnIndex})',
          headerClassName: '给表头的单元格附加 className，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          footerClassName: '给表尾的单元格附加 className，也可以是函数 Function({$rowIndex, column, columnIndex, $columnIndex})',
          formatter: '格式化显示内容 Function({cellValue, row, column})',
          indexMethod: '即将废弃，请使用 seqMethod',
          seqMethod: '只对 type=seq 有效，自定义索引方法 Function({row, rowIndex, column, columnIndex})',
          sortable: '是否允许列排序',
          sortBy: '只对 sortable 有效，自定义排序的属性',
          sortMethod: '只对 sortable 有效，列的排序方法，该方法 Function(prevRow, nexRow) 的返回值用来决定该行的排序规则',
          remoteSort: '是否使用服务端排序，如果设置为 true 则不会对数据进行处理',
          filters: '配置筛选条件（注：筛选只能用于列表，如果是树结构则过滤根节点）',
          filterMultiple: '只对 filters 有效，筛选是否允许多选',
          filterMethod: '只对 filters 有效，列的筛选方法，该方法 Function({value, row, column}) 返回值用来决定该行是否显示',
          filterRender: '筛选渲染器配置项',
          treeNode: '只对 tree-config 配置时有效，指定为树节点',
          columnKey: '即将废弃，请使用 table.column-key',
          cellType: '只对特定功能有效，单元格值类型（例如：导出数据类型设置）',
          cellRender: '默认的渲染器配置项',
          editRender: '可编辑渲染器配置项',
          contentRender: '内容渲染配置项',
          params: '额外的参数（可以用来存放一些私有参数）'
        }
      },
      tooltip: {
        desc: {
          value: '是否显示',
          content: '显示内容',
          trigger: '触发方式',
          theme: '主题样式',
          size: '尺寸',
          zIndex: '自定义堆叠顺序（对于某些特殊场景，比如被遮挡时可能会用到）',
          isArrow: '是否显示箭头',
          enterable: '鼠标是否可进入到 tooltip 中',
          leaveDelay: '鼠标移出后延时多少才隐藏 tooltip'
        }
      },
      grid: {
        desc: {
          formConfig: '表单配置项',
          toolbar: '工具栏配置',
          pagerConfig: '分页配置项',
          zoomConfig: '缩放配置项',
          proxyConfig: '数据代理配置项（基于 Promise API）',
          toolbarRender: '工具栏渲染器配置项'
        }
      },
      toolbar: {
        desc: {
          id: '即将废弃',
          size: '尺寸',
          loading: '是否加载中',
          import: '导入按钮配置（需要设置 "import-config"）',
          export: '导出按钮配置（需要设置 "export-config"）',
          print: '打印按钮配置',
          refresh: '刷新按钮配置',
          resizable: '即将废弃，请使用 custom-config',
          setting: '即将废弃，请使用 custom',
          custom: '自定义列配置'
        }
      },
      pager: {
        desc: {
          size: '尺寸',
          loading: '是否加载中',
          layouts: '自定义布局',
          currentPage: '当前页',
          pageSize: '每页大小',
          total: '总条数',
          pagerCount: '显示页码按钮的数量',
          pageSizes: '每页大小选项列表',
          align: '对齐方式',
          border: '带边框',
          background: '带背景颜色',
          iconPrevPage: '自定义上一页图标',
          iconJumpPrev: '自定义向上跳页图标',
          iconJumpNext: '自定义向下跳页图标',
          iconNextPage: '自定义下一页图标',
          iconJumpMore: '自定义跳页显示图标'
        }
      },
      radio: {
        desc: {
          value: '绑定值',
          label: '值',
          size: '尺寸',
          disabled: '是否禁用',
          name: '原生 name 属性'
        }
      },
      checkbox: {
        desc: {
          value: '绑定值',
          size: '尺寸',
          disabled: '是否禁用',
          label: '只对 checkbox-group 有效，值',
          title: '标题',
          indeterminate: '是否不确定状态'
        }
      },
      input: {
        desc: {
          value: '绑定值',
          size: '尺寸',
          disabled: '是否禁用',
          prefixIcon: '头部图标',
          suffixIcon: '尾部图标'
        }
      },
      button: {
        desc: {
          content: '内容（支持开启国际化）',
          type: '类型',
          size: '尺寸',
          name: '用来标识这一项',
          icon: '前缀图标',
          status: '按钮的图标',
          disabled: '是否禁用',
          loading: '是否加载中',
          placement: '固定显示下拉面板的方向',
          transfer: '是否将弹框容器插入于 body 内（对于嵌入到表格或者弹窗中被遮挡时需要设置为 true）'
        }
      },
      modal: {
        desc: {
          value: '绑定值',
          loading: '是否加载中',
          id: '设置唯一的 id（对于 Message 防止重复弹出 或 Storage 拖动状态保存等场景可能会用到）',
          title: '窗口的标题（支持开启国际化）',
          type: '窗口类型',
          status: '只对 type=alert | confirm | message 有效，消息状态',
          iconStatus: '自定义状态图标',
          message: '窗口的内容',
          showHeader: '是否显示头部',
          showFooter: '是否显示底部',
          lockView: '是否锁住页面，不允许窗口之外的任何操作',
          lockScroll: '是否锁住滚动条，不允许页面滚动',
          mask: '是否显示遮罩层',
          maskClosable: '是否允许点击遮罩层关闭窗口',
          escClosable: '是否允许按 Esc 键关闭窗口',
          resize: '是否允许拖动调整窗口大小',
          duration: '只对 type=message 有效，自动关闭的延时，如果为 -1 禁用自动关闭',
          size: '尺寸',
          width: '窗口的宽度',
          height: '窗口的高度',
          minWidth: '窗口的最小宽度',
          minHeight: '窗口的最小高度',
          top: '只对 type=message 有效，消息距离顶部的位置',
          position: '只对 type=modal 有效，窗口的默认位置，可以设置为 center 居中显示',
          zIndex: '自定义堆叠顺序（对于某些特殊场景，比如被遮挡时可能会用到）',
          showTitleOverflow: '设置标题内容过长时显示为省略号',
          fullscreen: '默认最大化显示',
          dblclickZoom: '只对 type=modal 有效，是否允许通过双击头部放大或还原窗口',
          remember: '记忆功能，会记住最后操作状态，再次打开窗口时还原窗口状态',
          destroyOnClose: '在窗口关闭时销毁内容',
          storage: '是否启用 localStorage 本地保存，会将窗口拖动的状态保存到本地（需要设置 id）'
        }
      },
      form: {
        desc: {
          loading: '是否加载中',
          data: '表单数据',
          span: '所有项的栅格占据的列数（共 24 分栏）',
          align: '所有项的内容对齐方式',
          size: '尺寸',
          titleAlign: '所有项的标题对齐方式',
          titleWidth: '所有项的标题宽度',
          titleColon: '是否显示标题冒号',
          rules: '校验规则配置项'
        }
      },
      formItem: {
        desc: {
          field: '字段名',
          title: '标题（支持开启国际化）',
          span: '栅格占据的列数（共 24 分栏）',
          align: '内容对齐方式',
          titleAlign: '标题对齐方式',
          titleWidth: '标题宽度',
          folding: '默认收起',
          visibleMethod: '该方法 Function({data, property}) 的返回值用来决定该项是否显示',
          collapseNode: '折叠节点',
          titlePrefix: '前缀配置项',
          titleSuffix: '后缀配置项',
          resetValue: '重置时的默认值',
          itemRender: '项渲染器配置项'
        }
      },
      select: {
        desc: {
          value: '绑定值',
          size: '尺寸',
          placeholder: '空值显示的占位符',
          clearable: '当有值时，是否在右侧显示清除按钮',
          disabled: '是否禁用',
          prefixIcon: '头部图标',
          placement: '固定显示下拉面板的方向',
          transfer: '是否将弹框容器插入于 body 内（对于嵌入到表格或者弹窗中被遮挡时需要设置为 true）'
        }
      },
      optgroup: {
        desc: {
          label: '显示内容',
          disabled: '是否禁用',
          size: '尺寸'
        }
      },
      option: {
        desc: {
          value: '绑定值',
          label: '显示内容',
          disabled: '是否禁用',
          size: '尺寸'
        }
      },
      switch: {
        desc: {
          value: '绑定值',
          size: '尺寸',
          disabled: '是否禁用',
          onLabel: '打开时显示的文字',
          offLabel: '关闭时显示的文字',
          onValue: '打开时的值',
          offValue: '关闭时的值',
          onIcon: '打开时的图标',
          offIcon: '关闭时的图标',
          onClass: '打开时的 className',
          offClass: '关闭时的 className'
        }
      },
      list: {
        desc: {
          data: '列表数据',
          size: '尺寸'
        }
      },
      pulldown: {
        desc: {
          data: '列表数据',
          size: '尺寸',
          disabled: '是否禁用',
          placement: '固定显示下拉面板的方向',
          transfer: '是否将弹框容器插入于 body 内（对于嵌入到表格或者弹窗中被遮挡时需要设置为 true）'
        }
      }
    }
  }
}
